<template>
  <div data-qa="transferfundsownaccountpayeelist-div-5rts7q">
    <v-list-item
      two-line
     data-qa="transferfundsownaccountpayeelist-list-item-tw9km">
      <v-list-item-content data-qa="transferfundsownaccountpayeelist-list-item-content-d59jht">
        <v-list-item-title data-qa="transferfundsownaccountpayeelist-list-item-title-n17jkm">
          <v-text-field data-qa="transferfundsownaccountpayeelist-text-field-l0gle"
            v-model="search"
            :label="t.accountSearchLabel"
            :color="primaryColor"
            prepend-inner-icon="mdi-magnify"
            class="transferFunds--custom-textfield"
            maxlength="20"
            clearable
            filled
          />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list
      two-line
      flat
      v-if="filteredPayees.length"
      class="mt-n10"
     data-qa="transferfundsownaccountpayeelist-list-1yrv8">
      <v-list-item-group :color="primaryColor" data-qa="transferfundsownaccountpayeelist-list-item-group-ovek8i">
        <v-list-item
          v-for="(item, i) in filteredPayees"
          :key="item.accountId"
          @click="$emit('payee-selected', item)"
          :data-qa="`transferfundsownaccountpayeelist-list-item-2j8v0-${i}`"
        >
          <v-list-item-content :data-qa="`transferfundsownaccountpayeelist-list-item-content-ezmuaa-${i}`">
            {{ formatPrimaryLine(item) }}
            <v-list-item-subtitle :data-qa="`transferfundsownaccountpayeelist-list-item-subtitle-kv1v8-${i}`"
              v-text="formatSecondaryLine(item)"
            />
            <v-divider :data-qa="`transferfundsownaccountpayeelist-divider-fnpf4-${i}`"  class="mt-2"/>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-row v-else no-gutters justify="center" class="pa-2" data-qa="transferfundsownaccountpayeelist-row-cvubsp">
      {{ t.notAvailable }}
    </v-row>
  </div>
</template>

<script>
import { formatPrimaryLine, formatSecondaryLine } from '../../../util/accountUtil'

export default {
  name: 'TransferFundsOwnAccountPayeeList',
  props: {
    payor: Object,
    payeeList: Array,
    isRecurring: Boolean,
    isFutureDated: Boolean
  },
  data () {
    return {
      search: '',
      t: {
        accountSearchLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('transferfunds.accountSearchLabelIBAN') : this.$t('transferfunds.accountSearchLabel'),
        notAvailable: this.$t('payee.notAvailable'),
        balLabel: this.$t('common.balLabel')
      }
    }
  },
  computed: {
    settings () {
      const { payments, allowInactiveAccountTransactionalOperations } = this.$appSettings.defaultConfigurations
      return {
        allowPaymentsToOtherISA: payments.allowPaymentsToOtherISA,
        allowedSourceAccountTypesForLisaPayee: payments.allowedSourceAccountTypesForLisaPayee,
        allowedPayeeAccountTypesForLisaSource: payments.allowedPayeeAccountTypesForLisaSource,
        allowInactiveAccountTransactionalOperations
      }
    },
    filteredPayees () {
      if (!this.payeeList.length) return []

      const payeeAccountsForNonRecurring = ['SVGS', 'CACC', 'NACC', 'TXEA', 'TXNA', 'TXFR', 'TXLA']
      const payeeAccountsForRecurring = ['SVGS', 'CACC', 'NACC', 'TXEA', 'TXNA']

      return this.payeeList
        .filter(payee =>
          payee.postingsRestriction !== 'CREDIT' &&
          payee.currency === this.payor?.currency &&
          (payee.accountStatus !== 'INACTIVE' || this.settings.allowInactiveAccountTransactionalOperations) &&
          (this.isRecurring || this.isFutureDated
            ? payeeAccountsForRecurring.includes(payee.accountType)
            : payeeAccountsForNonRecurring.includes(payee.accountType)) &&
          this.isCashIsaPayeeAllowed(payee) &&
          this.isLisaPayeeAllowed(payee) &&
          this.isPayeeAllowedForLisaPayor(payee) &&
          this.matchesSearch(this.search, payee)
        )
    }
  },
  methods: {
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    matchesSearch (search, { accountName, accountDescription, accountId, iban }) {
      if (!search) return true

      const searchLC = search.toLowerCase()
      return accountDescription?.toLowerCase().includes(searchLC) ||
        accountName?.toLowerCase().includes(searchLC) ||
        accountId?.toLowerCase().includes(searchLC) ||
        (iban ? iban.toLowerCase().includes(searchLC) : false)
    },
    isCashIsa (accountType) {
      return ['TXSV', 'TXNA', 'TXFR', 'TXEA', 'TXLA'].includes(accountType)
    },
    isCashIsaPayeeAllowed ({ accountType: payeeAccountType }) {
      return this.isCashIsa(this.payor.accountType) && this.isCashIsa(payeeAccountType)
        ? this.settings.allowPaymentsToOtherISA
        : true
    },
    isLisaPayeeAllowed (payee) {
      const { lisaDetails = {}, accountType: payeeAccountType } = payee
      const isLisaStatusAllowed = ['OPEN', 'SUBSCRIBED', 'ACTIVE'].includes(lisaDetails?.lisaStatus)
      const isSourceAccountTypeAllowed = this.settings.allowedSourceAccountTypesForLisaPayee.includes(this.payor.accountType)

      return payeeAccountType !== 'TXLA' || (isLisaStatusAllowed && isSourceAccountTypeAllowed)
    },
    isPayeeAllowedForLisaPayor ({ accountType: payeeAccountType }) {
      return this.payor.accountType !== 'TXLA' ||
        this.settings.allowedPayeeAccountTypesForLisaSource.includes(payeeAccountType)
    },
    formatPrimaryLine,
    formatSecondaryLine
  }
}
</script>
